export enum CustomerType {
  CLIENTE_COMPLETO = 1,
  CLIENTE_INCOMPLETO = 2,
  NO_CLIENTE = 3,
}

export interface IUser {
  name: string;
  customerType: CustomerType;
  firstname: string;
  lastname: string;
  taxNumber: string;
  address: string;
  telephone: string;
  terms: boolean;
}
